module.exports = __webpack_public_path__ + "static/media/download (1).be5e2f7f.svg";